import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
import { FileService } from 'src/app/service/file.service';


import { environment } from 'src/environments/environment';
import { Console } from 'console';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { EnrollmentReportService } from 'src/app/service/enrollment-report.service';

declare let pdfMake: any;
declare var $: any;
@Component({
  selector: 'app-enrolment-reports-group',
  templateUrl: './enrolment-reports-group.component.html',
  styleUrls: ['./enrolment-reports-group.component.scss']
})
export class EnrolmentReportsGroupComponent implements OnInit {
  studentForm: boolean = true;
  groupForm: boolean = false;
  subjectForm: boolean = false;
  select:any;
  showLoader: boolean = false;
  searchByFields: any;
  students: any;
  table: any;
  courses: any = [];
  studentCoursesModalLoader = false;
  years: any;
  semesters: any;
  batches: any;
  groups:any;
  orgId : any;
  username : any;
  lastSelectYear :any =0;
  lastSelectSemester :any=0;
  lastSelectBatch:any=0;
  lastSelectBatchName:any='';
  lastSelectSemesterName:any='';
  lastSelectGroupName:any='';
  lastSelectGroupCode:any='';
  lastSelectGroup:any=0;
  tableAppear:boolean =false;
  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),
    group: new FormControl('', [
      Validators.required,
    ]),
  });

 
  constructor(private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService,private fileService: FileService
    , private enrollmentGroupService: EnrollmentGroupService, private enrollmentReportService:EnrollmentReportService) { }
  
  ngOnInit(): void {
    this.getYears();
    this.getGroups();
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    // this.students = [
    //   {
    //   matNo: 1002,
    //   studentNameAR: "محمود رضا",
    //   studentNameEN: "Mahmoud reda",
    //   gender: "Male"
    // },
    //   {
    //     matNo: 1003,
    //     studentNameAR: "محمود رضا شعبتن",
    //     studentNameEN: "Mahmoud reda shabaan",
    //     gender: "Male"
    // },
  // ];

  
  // this.updateTable();
  // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
  //   this.updateTable();
  //   //this.initFormDropDownsFields();
  // });
  }

 
  updateTable() {
    let titleValue ='Academic Year '+ this.lastSelectYear;
    let messageTopValue=this.lastSelectSemesterName+' , '+this.lastSelectBatchName+'  Batch.'+' , '+this.lastSelectGroupName+' ('+this.lastSelectGroupCode+').';
    pdfMake.fonts = {
      Arial: {
        normal: 'arial.ttf',
        bold: 'arialbd.ttf',
        italics: 'ariali.ttf',
        bolditalics: 'arialbi.ttf'
      }
    };
    console.log("datatable")
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
       $(document).ready(function () {     
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        pageLength: 5,
        lengthChange: false,
        info: true,
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
            title :titleValue,
            messageTop: messageTopValue,
            extend: 'excelHtml5',
            text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
            titleAttr: 'enall',
            attr:  {
              id: 'enall',
              
            },
          exportOptions: {
            columns: [0, 1, 2, 3,4]
           // columns: [ ':visible' ]
          }},
          
        ],
      });
    }, 1);
  });
  }
  
  searchFormChange() { }
  searchFormSubmit() {
       if (this.searchForm.valid) {
      this.lastSelectYear = this.searchForm.controls.year.value;
      this.lastSelectSemester = this.searchForm.controls.semester.value;
      this.lastSelectBatch = this.searchForm.controls.batch.value;
      this.lastSelectGroup = this.searchForm.controls.group.value;
  
      if (this.lastSelectYear && this.lastSelectSemester&&this.lastSelectBatch) {
        if(this.batches.length > 0)
        {
          this.lastSelectBatchName = this.batches.filter((element: any) => element.id == this.lastSelectBatch)[0].gradeNameEn;
        }
        if(this.semesters.length > 0)
        {
          this.lastSelectSemesterName = this.semesters.filter((element: any) => element.id == this.lastSelectSemester)[0].semesterNameEn;
          
        }
        if(this.groups.length > 0)
        {
          this.lastSelectGroupName = this.groups.filter((element: any) => element.id == this.lastSelectGroup)[0].egroupNameEn;
          this.lastSelectGroupCode = this.groups.filter((element: any) => element.id == this.lastSelectGroup)[0].egroupCode;
        }
        this.enrollmentReportService.getAllStudentReportByGroup(this.orgId, this.lastSelectYear, this.lastSelectSemester,this.lastSelectBatch,this.lastSelectGroup)
          .subscribe(
            data => {
              this.students = data;
              if(this.students.length>=1){
              this.tableAppear=true;
              }else{
                this.tableAppear=false;
              }
              this.updateTable();
            },
            error => {
              this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
            }
          );
      } else {
        this.searchForm.controls.batch.reset();
        this.batches = [];
      }
    
    } else {
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
  }

  test(){
    console.log(this.table.rows( {selected: true}).data().toArray());
   // let currentDatatableRows = this.table.rows({ select: 'current' }).data().toArray();
   //.rows({ select: 'current' }).data().toArray()
  }

  

  showStudentCourses(studMatNo:any){
    console.log(studMatNo);
    $("#studentCoursesModal").modal('show');
  }
  changeReportType() {
    console.log(this.searchForm.controls.reportType.value);
    if(this.searchForm.controls.reportType.value=='student'){
      this.studentForm= true; 
      this.groupForm= false;
      this.subjectForm = false;
      this.updateTable();
    }else if(this.searchForm.controls.reportType.value=='subject'){
      this.studentForm= false;
      this.groupForm= false;
      this.subjectForm = true;
      this.updateTable();
    }else if (this.searchForm.controls.reportType.value=='group'){
      this.studentForm= false;
      this.groupForm= true;
      this.subjectForm = false;
      this.updateTable();
    }else{
      this.studentForm= false;
      this.groupForm= false;
      this.subjectForm = false;
      this.updateTable();
    }
    
  }

  getYears() {
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }
  getGroups() {
    this.enrollmentGroupService.getAllGroups()
      .subscribe(
        data => {
          this.groups = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

}
